import {hitAlgolytics} from "@pg-mono/algolytics";

import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {getTrackedSiteData} from "../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {ViewType} from "../../view_type/ViewType";
import {IOfferDetailPropertiesResponse} from "../api/fetch_first_properties";
import {FloorNumeric} from "../types/Floor";
import {SearchFormValuesType} from "../views/PropertyConfigurator";

export const hitPropertyConfiguratorSearch = (formValues: SearchFormValuesType, data: IOfferDetailPropertiesResponse) => {
    const vendorId = data.results.map((value) => value.offer.vendor.id);
    const offerId = data.results.map((value) => value.offer.id);
    const searchRegionId = formValues.search?.regions?.length >= 1 ? formValues.search?.regions?.map((region: ISelectedRegion) => region.id) : null;

    const payload = {
        view_type: ViewType.PROPERTY_CONFIGURATOR,
        search_area_lower: parseInt(formValues.area.lower) || null,
        search_area_upper: parseInt(formValues.area.upper) || null,
        search_price_lower: parseInt(formValues.price.lower) || null,
        search_price_upper: parseInt(formValues.price.upper) || null,
        search_rooms_lower: parseInt(formValues.rooms.lower) || null,
        search_rooms_upper: parseInt(formValues.rooms.upper) || null,
        search_additional_areas:
            formValues.rooms_area_type_selected?.filter((value: string) => value?.includes("as_")).map((value: string) => parseInt(value.split("as_")[1])) ||
            null,
        search_construction_end_date: formValues.construction_end_date?.[0] || null,
        search_distance: formValues.distance,
        additional_info: {
            quarters: formValues.world_directions?.map((direction: string) => parseInt(direction)) || null,
            search_floors_dict: formValues.floors?.map((floor: string) => FloorNumeric[floor as keyof typeof FloorNumeric]) || null,
            search_kitchen_type: formValues.kitchen_type?.map((type: string) => parseInt(type)),
            ...(formValues.instalment && !isNaN(parseInt(formValues.instalment)) ? {search_instalment: parseInt(formValues.instalment)} : {})
        },
        vendor_id: vendorId,
        offer_id: offerId,
        search_regions_ids: searchRegionId,
        ...getTrackedSiteData()
    };

    hitAlgolytics("search", payload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {getTrackedSiteData} from "../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {ViewType} from "../../view_type/ViewType";
import {IOfferDetailPropertiesResponse} from "../api/fetch_first_properties";
import {FloorNumeric} from "../types/Floor";
import {SearchFormValuesType} from "../views/PropertyConfigurator";

export const hitPropertyConfiguratorSearch = (formValues: SearchFormValuesType, data: IOfferDetailPropertiesResponse) => {
    const vendorId = data.results.map((value) => value.offer.vendor.id);
    const offerId = data.results.map((value) => value.offer.id);
    const searchRegionId = formValues.search?.regions?.length >= 1 ? formValues.search?.regions?.map((region: ISelectedRegion) => region.id) : null;

    const payload = {
        view_type: ViewType.PROPERTY_CONFIGURATOR,
        search_area_lower: parseInt(formValues.area.lower) || null,
        search_area_upper: parseInt(formValues.area.upper) || null,
        search_price_lower: parseInt(formValues.price.lower) || null,
        search_price_upper: parseInt(formValues.price.upper) || null,
        search_rooms_lower: parseInt(formValues.rooms.lower) || null,
        search_rooms_upper: parseInt(formValues.rooms.upper) || null,
        search_additional_areas:
            formValues.rooms_area_type_selected?.filter((value: string) => value?.includes("as_")).map((value: string) => parseInt(value.split("as_")[1])) ||
            null,
        search_construction_end_date: formValues.construction_end_date?.[0] || null,
        search_distance: formValues.distance,
        additional_info: {
            quarters: formValues.world_directions?.map((direction: string) => parseInt(direction)) || null,
            search_floors_dict: formValues.floors?.map((floor: string) => FloorNumeric[floor as keyof typeof FloorNumeric]) || null,
            search_kitchen_type: formValues.kitchen_type?.map((type: string) => parseInt(type)),
            ...(formValues.instalment && !isNaN(parseInt(formValues.instalment)) ? {search_instalment: parseInt(formValues.instalment)} : {})
        },
        vendor_id: vendorId,
        offer_id: offerId,
        search_regions_ids: searchRegionId,
        ...getTrackedSiteData()
    };

    hitAlgolytics("search", payload);
};
